module.exports = __webpack_public_path__ + "img/feel_icon.7ac3be01.svg";